import React from 'react';
import Match from '../events-by-date/Match';

export default function Events(props) {
    return (
        <>
            <span className="heading text-medium">{props.title}</span>
            {props.items.map(sport =>
                sport.map(match =>
                    <React.Fragment key={match.uniqueId}>
                        <Match
                            match={match}
                            aggregata={match.openAggregata}
                            bet={match.gruppiScommessa[0].scommesse[0]}
                            expanded={true}
                            showTournamentDesc={true} />
                    </React.Fragment>
                )
            )}
        </>
    );
}
